<template>
  <div class="dashboard-card">
    <article class="dashboard-card__content">
      <a :href="card.route">
        <img
          :src="card.image.src"
          :alt="card.image.alt"
          class="dashboard-card__image"
        />
        <section
          class="dashboard-card__body"
          :class="index ? `dashboard-card__body--color-${index}` : ''"
        >
          <h2>
            {{ card.title }}
          </h2>
        </section>
      </a>
    </article>
  </div>
</template>

<script>
  export default {
    props: {
      card: {
        type: Object,
        required: true,
      },
      index: {
        type: [Number, Boolean],
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .dashboard-card {
    padding: 0 5px;

    &__content {
      border-radius: 8px;
      transform: scale(1);
      box-shadow: 6px 6px 6px rgba(0, 0, 0, 0.15);

      overflow: hidden;

      transition: transform 250ms ease-in-out;

      > a {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        &:hover {
          text-decoration: none;
        }
      }

      &:hover {
        transform: scale(1.05);
        transition: transform 250ms ease-in-out;
      }

      @media screen and (min-width: 1400px) {
        max-width: 270px;
      }
    }

    &__image {
      object-fit: cover;
      object-position: 60% 45%;
      aspect-ratio: 16 / 9;

      width: 100%;
      height: 100%;
    }

    &__body {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
      min-height: 150px;

      h2 {
        margin: 0;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 26px;
        line-height: 41px;
        /* identical to box height */

        text-align: center;
        height: fit-content;
        color: #ffffff;
      }

      &--color-1 {
        background: linear-gradient(to right, #006742, #09a684);
      }
      &--color-2 {
        background: linear-gradient(to right, #09a684, #5ab5a2);
      }
      &--color-3 {
        background: linear-gradient(to right, #5ab5a2, #a9dcd6);
      }
      &--color-4 {
        background: linear-gradient(to right, #a9dcd6, #65a9d2);
      }
      &--color-5 {
        background: linear-gradient(to right, #65a9d2, #3075a4);
      }
      &--color-6 {
        background: linear-gradient(to right, #3075a4, #183a62);
      }
    }
  }
</style>
